import { createFileRoute } from "@tanstack/react-router";
import { AppDownloadSection } from "@/components/AppDownloadSection";

const faqs = [
  {
    q: "O APK do MEI Toolbox é seguro?",
    a: "Sim. O APK é distribuído diretamente pelo site oficial meitoolbox.com.br, sem intermediários. Nunca baixe o app por links desconhecidos enviados por terceiros.",
  },
  {
    q: "Como instalar o APK no Android?",
    a: 'Toque em "Baixar APK para Android", abra o arquivo baixado, permita a instalação de fontes desconhecidas se o Android solicitar e confirme em "Instalar".',
  },
  {
    q: "Preciso da Play Store para instalar?",
    a: "Não. A instalação é feita manualmente a partir do APK baixado, sem precisar da Google Play Store.",
  },
  {
    q: "O app é gratuito?",
    a: "Sim. O MEI Toolbox para Android é 100% gratuito, sem cadastro obrigatório e sem cobranças escondidas.",
  },
  {
    q: "O que fazer se o download do APK não iniciar?",
    a: 'Verifique sua conexão com a internet e se o armazenamento do celular tem espaço livre. Toque novamente em "Baixar APK para Android". Em alguns navegadores, confirme o download na barra de notificações.',
  },
  {
    q: "O Android bloqueou a instalação. O que fazer?",
    a: 'O Android pode exibir um aviso sobre fontes desconhecidas. Toque em "Configurações" na mensagem e habilite a permissão para o navegador usado. Depois, retorne à tela de instalação e toque em "Instalar".',
  },
  {
    q: "O app funciona sem internet?",
    a: "A maioria das ferramentas e calculadoras funciona offline. Recursos que dependem de dados atualizados, como notícias e artigos recentes, precisam de conexão com a internet.",
  },
  {
    q: "Como atualizar o MEI Toolbox para uma nova versão?",
    a: "Baixe novamente o APK mais recente no site oficial e instale por cima da versão atual. Seus dados e configurações são preservados automaticamente.",
  },
  {
    q: "O APK funciona em tablets Android?",
    a: "Sim. O aplicativo é compatível com smartphones e tablets Android que atendam ao requisito mínimo de Android 8.0 (API 26).",
  },
  {
    q: "É preciso ter conta Google para usar o app?",
    a: "Não. O MEI Toolbox não exige login com Google, e-mail ou qualquer cadastro para acessar as ferramentas e recursos gratuitos.",
  },
  {
    q: "O app consome muitos dados móveis?",
    a: "Não. O aplicativo é leve (12,8 MB) e a maioria das funcionalidades funciona offline. O consumo de dados é mínimo e ocorre apenas ao carregar artigos ou atualizações.",
  },
  {
    q: "Qual a diferença entre o APK e a versão do site?",
    a: "O APK oferece acesso rápido direto do celular, com atalho na tela inicial e funcionalidades otimizadas para mobile. A versão web continua disponível em meitoolbox.com.br com os mesmos recursos.",
  },
];

export const Route = createFileRoute("/download-app")({
  head: () => ({
    meta: [
      { title: "MEI Toolbox App Android – Baixar APK Oficial Grátis" },
      {
        name: "description",
        content:
          "Baixe o aplicativo oficial do MEI Toolbox para Android. Acesse calculadoras, ferramentas, documentos e recursos gratuitos para MEI diretamente do seu celular.",
      },
      { property: "og:title", content: "MEI Toolbox App Android – Baixar APK Oficial Grátis" },
      {
        property: "og:description",
        content:
          "Baixe o aplicativo oficial do MEI Toolbox para Android. Acesse calculadoras, ferramentas, documentos e recursos gratuitos para MEI diretamente do seu celular.",
      },
      { property: "og:url", content: "https://meitoolbox.com.br/download-app" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://meitoolbox.com.br/download-app" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: DownloadAppPage,
});

function DownloadAppPage() {
  return (
    <>
      <section className="container mx-auto px-4 pt-10 sm:pt-14 md:pt-20 pb-2 max-w-3xl text-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-primary">
          Android · APK oficial
        </div>
        <h1 className="mt-4 font-display text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight text-balance">
          Baixar App MEI Toolbox para Android
        </h1>
        <p className="mt-4 text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto">
          Instale o aplicativo no seu celular e tenha todas as ferramentas para MEI na palma da mão
          — grátis, sem cadastro.
        </p>
      </section>

      <AppDownloadSection />

      <section className="container mx-auto px-4 py-10 sm:py-14 md:py-20 max-w-3xl">
        <div className="text-center mb-8">
          <div className="text-[11px] sm:text-xs font-bold uppercase tracking-widest text-primary mb-2">
            FAQ
          </div>
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold">
            Dúvidas frequentes sobre o APK
          </h2>
        </div>
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <details
              key={i}
              className="group rounded-2xl border border-border bg-card p-4 sm:p-5 shadow-soft open:shadow-elevated transition"
            >
              <summary className="cursor-pointer list-none flex items-start justify-between gap-3 font-semibold py-1">
                <span className="text-[15px] sm:text-base">{f.q}</span>
                <span className="shrink-0 flex h-8 w-8 items-center justify-center rounded-full bg-primary/10 text-primary group-open:rotate-45 transition-transform">
                  +
                </span>
              </summary>
              <p className="mt-3 text-muted-foreground leading-relaxed text-[15px] sm:text-base">
                {f.a}
              </p>
            </details>
          ))}
        </div>
      </section>
    </>
  );
}
